import BaseAPIService from '../base/base-api-service';
import env from 'src/shared/env';
import ProductModel from 'src/model/product.model';

class FlyersCaService extends BaseAPIService<any> {
  private wpBaseURL: string = env.REACT_APP_BASE_WORDPRESS_URL;
  public endpoint: string = 'wp-json/acf/v3/dynamicFlyer?page=1&per_page=100';
  private BasicURL: string = env.REACT_APP_BASE_API_URL;
  public pricesendpoint: string = 'navapp/v1/product/search-mfc';
  public flyerendpoint: string = 'wp-json/acf/v3/flyerbanner?page=1&per_page=100';

  constructor() {
    super(ProductModel);
  }

  public sortArray = (data: any) => {
    data.sort((a: any, b: any) => {
      return a.acf.order - b.acf.order;
    });
    return data;
  };

  public addImages = (data: any, product: any, start: number, end: number) => {
    const startIndex = start;
    data.forEach((prodObj: any, index: number) => {
      const customIndex = startIndex + index;
      if (customIndex > end) {
        return;
      }
      prodObj.brand = product[customIndex].acf.brand;
      prodObj.product_image = product[customIndex].acf.product_image;
      prodObj.view_details = product[customIndex].acf.view_details;
      prodObj.product_section = product[customIndex].acf.product_section;
      prodObj.description = product[customIndex].acf.description;
    });
    return data;
  };

  public getProducts(): Promise<any> {
    return this.doRequest({
      url: this.wpBaseURL + this.endpoint,
      method: 'get'
    }).then(result => {
      return this.sortArray(result.data);
    });
  }

  public getPriceList(prices: any, product: any, start: number, end: number): Promise<any> {
    return this.doRequest({
      baseURL: this.BasicURL,
      method: 'post',
      url: this.pricesendpoint,
      data: {
        products: prices
      }
    })
      .then(response => {
        const list = response.data;
        return this.addImages(list, product, start, end);
      })
      .catch(error => {
        throw error;
      });
  }

  public getFlyerBanner(): Promise<any> {
    return this.doRequest({
      url: this.wpBaseURL + this.flyerendpoint,
      method: 'get'
    }).then(result => {
      return result.data;
    });
  }
}

const flyersCaServiceInstance = new FlyersCaService();

export default flyersCaServiceInstance;
